export default {
      id: "about-symbols-06-usage",
      viewBox: "0 0 150 150",
      url: "/" + "sprite.svg#about-symbols-06",
      toString: function () {
        return this.url;
      }
    }